export default {
  getUserCampaigns(state) {
    return state.campaigns
  },
}
